import React from 'react';
import { I18n } from '@aws-amplify/core';
import { Row, Col, Radio, RadioChangeEvent } from 'antd';

import { useUpdateDuration } from '@/components/views/Report/Rosa/hooks/useUpdateDuration';
import { InfoTooltip } from '@/components/views/Report/Rosa/components/InfoTooltip';
import { useRosaContext } from '@/components/views/Report/Rosa/context';
import { useCategoryContext } from '../../context';
import { FormItem } from '../../../../styles';
import * as S from './styles';

export function Duration() {
	const { selectedSubCategory, fieldName } = useCategoryContext();
	const { organization_id, company_id, file_id } = useRosaContext();

	const { mutate: updateDuration } = useUpdateDuration({
		organization_id,
		company_id,
		report_id: file_id,
		sub_category_id: selectedSubCategory.id
	});

	function handleOnChange(e: RadioChangeEvent) {
		const duration = e.target.value;
		updateDuration({ duration });
	}

	return (
		<Row>
			<Col span={24}>
				<Row justify="end" align="middle" gutter={[0, 20]}>
					<Col span={24}>
						<Row gutter={[10, 0]} justify="end" align="middle">
							<S.Label lg={10} xxl={10}>
								<S.StyledTitle level={5}>{I18n.get('Duration')} </S.StyledTitle>
								<S.TooltipContainer>
									<InfoTooltip />
								</S.TooltipContainer>
							</S.Label>
							<Col span={14}>
								<S.ScoresContainer>
									<FormItem name={[...fieldName, 'duration']} style={{ position: 'relative' }}>
										<S.RadioGroup onChange={handleOnChange}>
											<Radio.Button value={-1}>-1</Radio.Button>
											<Radio.Button value={0}>0</Radio.Button>
											<Radio.Button value={1}>+1</Radio.Button>
										</S.RadioGroup>
									</FormItem>
								</S.ScoresContainer>
							</Col>
						</Row>
					</Col>
				</Row>
			</Col>
		</Row>
	);
}
